import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateAboutHome } from "../../api/apiAbout";

export const useUpdateAboutHome = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateAboutHome(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["about-home"] });
            toast.success(
                response?.message ||
                (isArabic ? "تم تحديث قسم من نحن (الرئيسية)" : "About Home section updated")
            );
        },
        onError: (error) => {
            const message =
                error?.response?.data?.message ||
                (isArabic ? "تعذر التحديث" : "Failed to update");
            toast.error(message);
        },
    });

    return mutation;
};
